import * as actions from './actions';

const initialState = {
    contacts: [],
    error: null,
    initial: false,
    loading: false,
};

export default function sendinblueContactsReducer(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_SENDINBLUE_CONTACTS_REQUEST:
            return { ...state, loading: true, error: null };

        case actions.FETCH_SENDINBLUE_CONTACTS_SUCCESS:
            return { ...state, initial: true, contacts: action.payload.data, loading: false, error: null };

        case actions.FETCH_SENDINBLUE_CONTACTS_FAILURE:
            return { ...state, initial: false, loading: false, error: action.payload.error };

        default:
            return state;
    }
}